'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { Motion } from '#pplx/frontend/aether/components/Motion/index.js';
import { template } from '#pplx/frontend/framework/templates/template.js';
const BottomCardSlotRoot = ({ children, isVisible = false, ref, }) => (_jsx("div", { ref: ref, "data-upsell-slot": "ask.home.page_bottom", className: "bottom-4 absolute left-0 flex w-full items-center justify-center pointer-events-none", children: _jsx(Motion.Expand, { isVisible: isVisible, children: _jsx("div", { className: "flex", children: children }) }) }));
const BottomUpsellSlotsLayout = ({ Slot, }) => _jsx(Slot, { slot: "bottomCard" });
export const BottomUpsellSlotsTemplate = template('BottomUpsellSlotsTemplate')
    .slot('bottomCard', BottomCardSlotRoot)
    .define(BottomUpsellSlotsLayout);
//# sourceMappingURL=BottomUpsellSlotsTemplate.js.map